module.exports = __webpack_public_path__ + "static/media/SIJNight.bf3ba350.png";